import { render } from "./LibraryCategories.vue?vue&type=template&id=bb409fe2"
import script from "./LibraryCategories.vue?vue&type=script&lang=js"
export * from "./LibraryCategories.vue?vue&type=script&lang=js"

import exportComponent from "C:\\devPrivate\\cmsDubaiMailing\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__